import React from "react";

interface SlicerErrorCardProps {
  /** Label to display in the error card (e.g. slicer label or name). */
  label: string;
  /** Slicer name used to construct the block id passed to onFixBlock. */
  slicerName: string;
  /** Error message forwarded to onFixBlock. */
  errorMessage: string;
  onFixBlock?: (blockId: string, errorMessage: string) => void;
}

export const SlicerErrorCard: React.FC<SlicerErrorCardProps> = ({
  label,
  slicerName,
  errorMessage,
  onFixBlock,
}) => {
  return (
    <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg border border-red-200 bg-red-50 text-sm">
      <span className="material-icons !text-base text-red-400">error_outline</span>
      <span className="text-red-600 font-medium truncate max-w-[120px]">{label}</span>
      {onFixBlock && (
        <button
          className="inline-flex items-center gap-1 px-2.5 py-1 rounded-md text-xs font-semibold bg-blue-600 text-white hover:bg-blue-700 active:bg-blue-800 transition-colors cursor-pointer"
          onClick={e => {
            e.stopPropagation();
            onFixBlock(`slicer_${slicerName}`, errorMessage);
          }}
        >
          <span className="material-icons" style={{ fontSize: 14 }}>
            auto_awesome
          </span>
          Fix
        </button>
      )}
    </div>
  );
};
